import { NgModule } from '@angular/core';
import { MomentModule } from 'angular2-moment';
import { DatePickerModule} from '../../components/date-picker/date-picker.module';
import { MdSelectModule } from '@angular/material';
import { SharedModule } from '../../shared/shared.module';

import { PaymentRoutingModule } from './payment.routing';

import { AccountPaymentComponent } from './account-payment/account-payment.component';
import { ListInvoiceComponent } from './account-payment/list-invoice/list-invoice.component';
import { PayInvoiceComponent } from './account-payment/pay-invoice/pay-invoice.component';
import { AddOrderPopupComponent } from './account-payment/list-invoice/add-order-popup.component';
import { RefundPopupComponent } from './account-payment/list-invoice/refund-popup.component';
import { CreditNotePopupComponent } from './account-payment/list-invoice/credit-note-popup.component';

@NgModule({
  declarations: [
  	AccountPaymentComponent,
    AddOrderPopupComponent,
    CreditNotePopupComponent,
    RefundPopupComponent,
    ListInvoiceComponent,
    PayInvoiceComponent
  ],
  imports: [
  	PaymentRoutingModule,
    MomentModule,
    SharedModule,
    MdSelectModule,
    DatePickerModule
  ],
  entryComponents: [
    AddOrderPopupComponent,
    CreditNotePopupComponent,
    RefundPopupComponent
  ],
  providers: [],
  bootstrap: []
})
export class PaymentModule { }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/payment/payment.module.ts